import React from 'react'
import { ModalContainer } from '@components/Modals/ModalContainer'
import { WalletMemberList } from '@components/SpaceSettingsPanel/WalletMemberList'
import { TokenSelectionDisplay } from '@components/Tokens/TokenSelector/TokenSelection'
import { useNativeTokenWithQuantity } from '@components/Tokens/utils'
import { Stack, Text } from '@ui'
import { Entitlements } from 'hooks/useEntitlements'
import { Address, Permission, useConnectivity, useHasPermission } from 'use-towns-client'

export function RequirementsModal({
    spaceId,
    title,
    onClose,
    entitlements,
}: {
    spaceId: string | undefined
    title: string
    onClose: () => void
    entitlements: Entitlements | undefined
}) {
    const nativeTokenWithQuantity = useNativeTokenWithQuantity(entitlements?.ethBalance || '')
    const { loggedInWalletAddress, isAuthenticated } = useConnectivity()

    const { hasPermission: meetsMembershipRequirements } = useHasPermission({
        spaceId: spaceId,
        walletAddress: loggedInWalletAddress,
        permission: Permission.JoinSpace,
    })

    if (!entitlements) {
        return null
    }

    return (
        <ModalContainer touchTitle={title} padding="lg" onHide={onClose}>
            <Stack gap="x4">
                {(entitlements?.tokens.length > 0 || entitlements?.ethBalance) && (
                    <Stack gap="md">
                        <Text strong>Holding any of the following tokens:</Text>
                        {nativeTokenWithQuantity && (
                            <TokenSelectionDisplay
                                elevate
                                token={nativeTokenWithQuantity}
                                userPassesEntitlement={
                                    isAuthenticated
                                        ? meetsMembershipRequirements !== undefined &&
                                          meetsMembershipRequirements
                                        : undefined
                                }
                            />
                        )}
                        {entitlements?.tokens.map((token) => (
                            <TokenSelectionDisplay
                                elevate
                                key={
                                    token.chainId + token.data.address + (token.data.tokenId ?? '')
                                }
                                token={token}
                                userPassesEntitlement={
                                    isAuthenticated
                                        ? meetsMembershipRequirements !== undefined &&
                                          meetsMembershipRequirements
                                        : undefined
                                }
                            />
                        ))}
                    </Stack>
                )}
                {entitlements?.users.length > 0 && (
                    <Stack gap="md">
                        <Text strong>Connecting any of the following addresses:</Text>
                        <WalletMemberList
                            isRole
                            readOnly
                            walletMembers={entitlements?.users as Address[]}
                        />
                    </Stack>
                )}
            </Stack>
        </ModalContainer>
    )
}
